import { render, staticRenderFns } from "./marketFrame.vue?vue&type=template&id=2104adbf&scoped=true"
import script from "./marketFrame.vue?vue&type=script&lang=js"
export * from "./marketFrame.vue?vue&type=script&lang=js"
import style0 from "./marketFrame.vue?vue&type=style&index=0&id=2104adbf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2104adbf",
  null
  
)

export default component.exports